import { Stack, Typography } from '@mui/material';
import { useContext } from 'react';

import { saveVenueDefaultDatas } from '@/domain/project-venue/actions/save-default-venue-datas';
import { VenueDefaultDatas } from '@/domain/project-venue/entities/project-venue.entity';
import { VenuePreset } from '@/domain/project-venue-presets/entities/project-venue-presets.entity.ts';
import { QuizPanelLayout } from '@/ui/components/quiz-panel/QuizPanelLayout';
import { useAppDispatch } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { EquipmentForm } from '@/ui/pages/app/project/venue/default-datas/components/forms/EquipmentForm';
import { DefaultDatasContext } from '@/ui/pages/app/project/venue/default-datas/default-datas-quiz-panel/DefaultDatasContext';

export function DefaultTechniqueQuiz({
  venueDefaultDatas,
  setVenueDefaultDatas,
  projectId,
}: {
  venueDefaultDatas: VenueDefaultDatas;
  setVenueDefaultDatas: React.Dispatch<React.SetStateAction<VenueDefaultDatas>>;
  projectId: number | undefined;
}) {
  const dispatch = useAppDispatch();
  const { panelOpen, setPanelOpen } = useContext(DefaultDatasContext);

  const onEdit = (venueDatas: VenueDefaultDatas) => {
    setVenueDefaultDatas(venueDatas);
    if (!projectId) return;
    dispatch(
      saveVenueDefaultDatas({
        projectId: projectId,
        properties: venueDatas,
      }),
    );
  };

  return (
    <QuizPanelLayout panelOpen={panelOpen} setPanelOpen={setPanelOpen}>
      <Stack>
        <Typography variant="h6">
          {translate(`ProjectsVenue.DefaultDatas.my-technique`)}
        </Typography>
      </Stack>

      <EquipmentForm
        onEdit={onEdit}
        venueDefaultDatas={venueDefaultDatas as VenuePreset}
      />
    </QuizPanelLayout>
  );
}
